import React from 'react'
import {cn} from '@containers/html-utils'

interface Props {
  children: React.ReactNode
  content: React.ReactNode
  className?: string
}

export const closePopup = () => {
  const parentToHide: HTMLElement = document.querySelector(
    '.content-on-hover-parent:hover'
  )

  if (!parentToHide) {
    return
  }
  parentToHide.className = parentToHide.className.replace(
    'content-on-hover-parent',
    'content-on-hover-parent-hide'
  )

  setTimeout(() => {
    parentToHide.className = parentToHide.className.replace(
      'content-on-hover-parent-hide',
      'content-on-hover-parent'
    )
  }, 100)
}

export const ContentOnHover = (props: Props) => {
  const {children, content, className} = props

  return (
    <div className={cn('relative', 'content-on-hover-parent', className)}>
      <div className="content-on-hover-child">{content}</div>
      {children}
    </div>
  )
}
